export default "__VITE_ASSET__CvQqU0wu__"